import BaseForm from './baseForm';

export default class Unsubscribe extends BaseForm {
  constructor() {
    super('unsubscribe-form');
  }

  init() {
    super.init('unsubscribe-form');
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('email')) {
      document.querySelector('[name="fields[email]"]').value = urlParams.get('email');
    }
  }

  getFormValidationConstraints() {
    return {
      ...this.emailConstraint('fields[email]')
    };
  }
}
